import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { IRxntPopupStateArgs } from '../../model';

@Injectable()
export class RxntPopupStateService {
  private _argsSubject: BehaviorSubject<IRxntPopupStateArgs | null>;

  constructor() {
    this._argsSubject = new BehaviorSubject<IRxntPopupStateArgs | null>(null);
  }

  get args(): IRxntPopupStateArgs | null {
    // last recorded shown/hidden value, does not mean all popups are shown or hidden
    return this._argsSubject.value;
  }

  get args$(): Observable<IRxntPopupStateArgs | null> {
    return this._argsSubject.asObservable();
  }

  emitArgs(value: IRxntPopupStateArgs): void {
    this._argsSubject.next(value);
  }
}
